var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            //"use strict";
            var DescriberHelper = /** @class */ (function () {
                function DescriberHelper() {
                }
                DescriberHelper.getName = function (inputClass) {
                    var funcNameRegex = /function (.{1,})\(/;
                    var results = (funcNameRegex).exec(inputClass.toString());
                    return (results && results.length > 1) ? results[1] : "";
                };
                DescriberHelper.getNameFromObjInstance = function (inputClass) {
                    var funcNameRegex = /function (.{1,})\(/;
                    var results = (funcNameRegex).exec(inputClass.constructor.toString());
                    return (results && results.length > 1) ? results[1] : "";
                };
                return DescriberHelper;
            }());
            Helpers.DescriberHelper = DescriberHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=describerhelper.js.map